import React, { useEffect, useState } from "react";
import { Button, Drawer } from "antd";
import dayjs from "dayjs";
import { CalendarIcon, PinIcon } from "../search-icons";
import OptionPickerSheet from "./OptionPickerSheet";
import MonthPickerSheet from "./MonthPickerSheet";
import SheetHeaderClose from "./SheetHeaderClose";
import { PickerGroup } from "./PickerList";
import { monthFormat } from "../../../../utils/antd.props";
import type { GroundFilterState } from "../../../../utils/groundListingParams";

interface Props {
  open: boolean;
  onClose: () => void;
  filters: GroundFilterState;
  destinationGroups: PickerGroup[];
  onSearch: (next: GroundFilterState) => void;
}

type SubSheet = "destination" | "date" | null;

// The series ModifySearchSheet cut down to the two fields ground tours search on.
export default function GroundModifySearchSheet({ open, onClose, filters, destinationGroups, onSearch }: Props) {
  const [draft, setDraft] = useState<GroundFilterState>(filters);
  const [sub, setSub] = useState<SubSheet>(null);

  useEffect(() => {
    if (open) setDraft(filters);
  }, [open, filters]);

  const search = () => {
    onSearch(draft);
    onClose();
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="bottom"
      height="100%"
      title="Modify Search"
      closable={false}
      extra={<SheetHeaderClose onClose={onClose} />}
      rootClassName="v2-sheet v2-sheet--search"
      footer={
        <Button type="primary" block className="v2-sheet__submit" onClick={search}>
          Search
        </Button>
      }
    >
      <div className="v2-modify">
        <button type="button" className="v2-modify__row" onClick={() => setSub("destination")}>
          <PinIcon size={20} />
          <span className={`v2-modify__value ${draft.keyword ? "" : "is-empty"}`}>
            {draft.keyword || "Where would you like to go?"}
          </span>
        </button>

        <button type="button" className="v2-modify__row" onClick={() => setSub("date")}>
          <CalendarIcon size={20} />
          <span className={`v2-modify__value ${draft.month ? "" : "is-empty"}`}>
            {draft.month ? dayjs(draft.month).format(monthFormat) : "Travel Date"}
          </span>
        </button>
      </div>

      <OptionPickerSheet
        open={sub === "destination"}
        onClose={() => setSub(null)}
        title="To Where?"
        placeholder="Where would you like to go?"
        fieldIcon={<PinIcon size={20} />}
        rowIcon={<PinIcon size={16} />}
        groups={destinationGroups}
        value={draft.keyword}
        allowFreeText
        onSelect={(option) => {
          setDraft({ ...draft, keyword: option.value });
          setSub(null);
        }}
      />

      <MonthPickerSheet
        open={sub === "date"}
        onClose={() => setSub(null)}
        value={draft.month}
        onApply={(month) => setDraft({ ...draft, month })}
      />
    </Drawer>
  );
}
